import { render, staticRenderFns } from "./ManageClub.vue?vue&type=template&id=4d6fb4a2&scoped=true&"
import script from "./ManageClub.vue?vue&type=script&lang=js&"
export * from "./ManageClub.vue?vue&type=script&lang=js&"
import style0 from "./ManageClub.vue?vue&type=style&index=0&id=4d6fb4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fb4a2",
  null
  
)

export default component.exports